import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Copyright IBM Corp. 2021, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
// Import portions of React that are needed.
import React from 'react'; // Other standard imports.

import { arrayOf, shape, string } from 'prop-types';
import { pkg
/*, carbon */
} from '../../settings'; // Carbon and package components we use.

import { Link } from 'carbon-components-react'; // The block part of our conventional BEM class names (blockClass__E--M).

var blockClass = "".concat(pkg.prefix, "--http-errors");
var componentName = 'HTTPErrorContent';
export var HTTPErrorContent = function HTTPErrorContent(_ref) {
  var description = _ref.description,
      errorCodeLabel = _ref.errorCodeLabel,
      title = _ref.title,
      links = _ref.links;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(blockClass, "__content")
  }, errorCodeLabel && /*#__PURE__*/React.createElement("p", {
    className: "".concat(blockClass, "__error-code-label")
  }, errorCodeLabel), title && /*#__PURE__*/React.createElement("h1", {
    className: "".concat(blockClass, "__title")
  }, title), description && /*#__PURE__*/React.createElement("p", {
    className: "".concat(blockClass, "__description")
  }, description), links && links.length && links.map(function (link) {
    return /*#__PURE__*/React.createElement(Link, _extends({}, link, {
      role: "link",
      href: link.href,
      key: link.text,
      className: "".concat(blockClass, "__link")
    }), link.text);
  }));
}; // The display name of the component, used by React. Note that displayName
// is used in preference to relying on function.name.

HTTPErrorContent.displayName = componentName; // The types and DocGen commentary for the component props,
// in alphabetical order (for consistency).
// See https://www.npmjs.com/package/prop-types#usage.

HTTPErrorContent.propTypes = {
  /**
   * String that will provide the description for the HTTP error code
   */
  description: string.isRequired,

  /**
   * String that will describe the error that occurred
   */
  errorCodeLabel: string.isRequired,

  /**
   * Links that will display for extra context when receiving particular errors
   */
  links: arrayOf(shape(_objectSpread(_objectSpread({}, Link.propTypes), {}, {
    /**
     * The text to display for the link
     */
    text: string.isRequired,

    /**
     * The link's destination
     */
    href: string.isRequired
  }))),

  /**
   * This will be for the main title of the HTTP error component
   */
  title: string.isRequired
};